import React from 'react';
import ConnectToStores from '../../../../Common/Utilities/Decorators/ConnectToStoresDecorator';
import RatesSearchStore from '../Stores/RatesSearchStore.js';
import RatesSearchActions from '../Actions/RatesSearchActions';
import RatesSearchView from './RatesSearchView.jsx';
import RateCardListView from './RateCardListView.jsx'
import NotificationActions from '../../../../Common/Actions/NotificationActions';
import LoadingSpinnerView from '../../../../Common/Components/LoadingSpinnerView.jsx';
import ReactDOM from 'react-dom';
import applyDecoratorsDoNotUseInNewCode from '../../../../Common/Utilities/Decorators/ApplyDecorators.js';

class RatesSearchPageView extends React.Component {
    currentlyDisplayedVersion = 0;

    static getStores(props) {
        return [RatesSearchStore]
    }

    static getPropsFromStores(props) {
        const store = RatesSearchStore.getState();
        return {
            searchCriteria: store.searchCriteria,
            options: store.options,
            searchCriteriaLoaded : store.searchCriteriaLoaded,
            rateCardsToView: store.rateCardsToView,
            resultVersion: store.resultVersion,
            canDeleteRateCards: ((store.authorisations.canDeleteRateCards == true) && (store.userCanDeleteCurrentRates))
        };
    }

    render() {
        delete this.resultElement;

        if (!this.props.searchCriteriaLoaded) {
            return <LoadingSpinnerView />;
        }

        return (
            <div>
                <RatesSearchView
                    searchCriteria={ this.props.searchCriteria }
                    options={ this.props.options }
                    onExportRequested={ this.onExportRequested }
                    onViewRequested={ this.onViewRequested } />
                {
                    this.props.rateCardsToView
                        ? <RateCardListView
                            ref={ resultElement => this.resultElement = resultElement }
                            rateCardsToView={ this.props.rateCardsToView }
                            onSelectionChanged={ this.onRateCardSelectionChanged }
                            onDeleteRequested={ this.onDeleteRequested }
                            canDeleteRateCards = { this.props.canDeleteRateCards } />
                        : null
                }
            </div>
        );
    }

    onRateCardSelectionChanged = ({ rateCard, isSelected }) => {
        RatesSearchActions.selectionChangedInUi(rateCard, isSelected);
    }

    componentDidMount() {
        RatesSearchActions.loadSearchCriteriaLookups();
        this.scrollResultsIntoViewIfRequired();
    }

    componentDidUpdate() {
        this.scrollResultsIntoViewIfRequired();
    }

    scrollResultsIntoViewIfRequired() {
        const propVersion = this.props.resultVersion;
        if(this.currentlyDisplayedVersion === propVersion)
            return;

        ReactDOM.findDOMNode(this.resultElement).scrollIntoView({ behavior: 'smooth' });
        this.currentlyDisplayedVersion = propVersion;
    }

    onDeleteRequested = (rateCardsToDelete) => {
        RatesSearchActions.deleteRateCards(rateCardsToDelete.map(rc => rc.get('rateCardId')));
    }

    onExportRequested = () => {
        RatesSearchActions.exportRates(this.props.searchCriteria, this.props.options);
    }

    onViewRequested = () => {
        RatesSearchActions.loadViewableRateCards(this.props.searchCriteria, this.props.options);
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores);

export default withDecorators(RatesSearchPageView);
